import { ConfigSelectOption } from 'store/types/SelectOption';
import ClaimStatus from 'store/enums/ClaimStatus';

const claimStatusConfig: Record<ClaimStatus, ConfigSelectOption> = {
  [ClaimStatus.Draft]: {
    name: ClaimStatus.Draft,
    theme: 'grey',
  },
  [ClaimStatus.Submitted]: {
    name: ClaimStatus.Submitted,
    theme: 'blue',
  },
  [ClaimStatus.PaymentDue]: {
    name: ClaimStatus.PaymentDue,
    theme: 'red',
  },
  [ClaimStatus.PaymentSubmitted]: {
    name: ClaimStatus.PaymentSubmitted,
    theme: 'green',
  },
  [ClaimStatus.Closed]: {
    name: ClaimStatus.Closed,
    theme: 'grey',
  },
  [ClaimStatus.InQueue]: {
    name: ClaimStatus.InQueue,
    theme: 'grey',
  },
  [ClaimStatus.DecisionIssued]: {
    name: ClaimStatus.DecisionIssued,
    theme: 'blue',
  },
  [ClaimStatus.UnderReview]: {
    name: ClaimStatus.UnderReview,
    theme: 'yellow',
  },
};

export default claimStatusConfig;
